var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioMegatron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F1F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.3335C20.414 15.644 20.75 16.0466 20.9814 16.5094C21.2128 16.9723 21.3333 17.4827 21.3333 18.0001C21.3333 18.5176 21.2128 19.028 20.9814 19.4909C20.75 19.9537 20.414 20.3563 20 20.6668M21.8 13.3335C22.496 13.8959 23.0573 14.6069 23.443 15.4144C23.8286 16.2218 24.0288 17.1053 24.0288 18.0001C24.0288 18.895 23.8286 19.7785 23.443 20.5859C23.0573 21.3934 22.496 22.1044 21.8 22.6668M14 20.0001H12.6667C12.4899 20.0001 12.3203 19.9299 12.1953 19.8049C12.0702 19.6799 12 19.5103 12 19.3335V16.6668C12 16.49 12.0702 16.3204 12.1953 16.1954C12.3203 16.0704 12.4899 16.0001 12.6667 16.0001H14L16.3333 13.0001C16.3916 12.887 16.4884 12.7984 16.6063 12.7503C16.7242 12.7023 16.8554 12.6981 16.9762 12.7383C17.0969 12.7786 17.1993 12.8607 17.2648 12.9698C17.3303 13.079 17.3546 13.208 17.3333 13.3335V22.6668C17.3546 22.7923 17.3303 22.9213 17.2648 23.0305C17.1993 23.1396 17.0969 23.2217 16.9762 23.262C16.8554 23.3022 16.7242 23.298 16.6063 23.2499C16.4884 23.2019 16.3916 23.1133 16.3333 23.0001L14 20.0001Z",
    stroke: "#27532D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMegatron);
export default __webpack_public_path__ + "static/media/AudioMegatron.7c827a26cc10a8543773a0ed0da2f952.svg";
export { ForwardRef as ReactComponent };